// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getMessaging } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    'production': {
        apiKey: "AIzaSyAgPC92Pu963D7yOYvwaO9WvPqiIf6aWNg",
        authDomain: "ecoeats-prod.firebaseapp.com",
        projectId: "ecoeats-prod",
        storageBucket: "ecoeats-prod.firebasestorage.app",
        messagingSenderId: "459459909626",
        appId: "1:459459909626:web:f4cb92d81a31ebf9613643",
        measurementId: "G-LN55ZSBZS2"
    },
    'development': {
        apiKey: "AIzaSyAyQS0t3ed3K-p6XAc9pIgCn5u64QNul-8",
        authDomain: "ecoeats-25565.firebaseapp.com",
        projectId: "ecoeats-25565",
        storageBucket: "ecoeats-25565.firebasestorage.app",
        messagingSenderId: "420024776090",
        appId: "1:420024776090:web:59c59b5247d47d083e3623",
        measurementId: "G-KG355XMKZN"
    },
    'test': {
        apiKey: "AIzaSyAyQS0t3ed3K-p6XAc9pIgCn5u64QNul-8",
        authDomain: "ecoeats-25565.firebaseapp.com",
        projectId: "ecoeats-25565",
        storageBucket: "ecoeats-25565.firebasestorage.app",
        messagingSenderId: "420024776090",
        appId: "1:420024776090:web:59c59b5247d47d083e3623",
        measurementId: "G-KG355XMKZN"
    }
};

// Initialize Firebase
export const env = process.env.REACT_APP_FIREBASE_ENV === 'test'
    ? 'test'             // TEST
    : process.env.REACT_APP_FIREBASE_ENV === 'development' ?
        'development' :    // QA
        'production';       // PROD

export const vapidKey = process.env.REACT_APP_FIREBASE_CLOUD_COMMUNICATION_PUBLIC_KEY

export const app = initializeApp(firebaseConfig[env]);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);

export const logEvent = (name: string, params: Record<string, any> = {}) => {
    // Ensure gtag() exists
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else {
      // Fallback: push into dataLayer so GTM can pick it up
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        ...params,
      });
    }
  };


export const functionsBaseUrl = process.env.REACT_APP_FIREBASE_ENV === 'test'
    ? 'http://127.0.0.1:5001/ecoeats-25565/us-central1'             // TEST
    : process.env.REACT_APP_FIREBASE_ENV === 'development' ?
        'https://us-central1-ecoeats-25565.cloudfunctions.net' :    // QA
        'https://us-central1-ecoeats-prod.cloudfunctions.net';       // PROD
// export const functionsBaseUrl: string = "http://127.0.0.1:5001/ecoeats-25565/us-central1";


(async () => {
    try {
        // Use 127.0.0.1 instead of localhost
        const authEmulatorUrl = "http://127.0.0.1:9099";
        await fetch(authEmulatorUrl);
        connectAuthEmulator(auth, authEmulatorUrl, {
            disableWarnings: true,
        });
        console.info("🎮 Firebase Auth: emulated");
    } catch (e) {
        console.info("🔥 Firebase Auth: not emulated");
    }
})();

(async () => {
    try {
        // Use 127.0.0.1 instead of localhost
        const host = "127.0.0.1";
        const port = 8080;
        await fetch("http://" + host + ":" + port);
        connectFirestoreEmulator(firestore, host, port);
        console.info("🎮 Firebase Firestore: emulated");
    } catch (e) {
        console.info("🔥 Firebase Firestore: not emulated");
    }
})();

(async () => {
    try {
        // Use 127.0.0.1 instead of localhost
        const host = "127.0.0.1";
        const port = 9199;
        await fetch("http://" + host + ":" + port);
        connectStorageEmulator(storage, host, port);
        console.info("🎮 Firebase Storage: emulated");
    } catch (e) {
        console.info("🔥 Firebase Storage: not emulated");
    }
})();
